import script from "./StudentCancellation.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCancellation.vue?vue&type=script&setup=true&lang=js"

import "./StudentCancellation.vue?vue&type=style&index=0&id=1081fc5e&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1081fc5e"]])

export default __exports__